<template>
  <div id="app" class="uk">
    <Header />
    <router-view />
  </div>
</template>
<script>
import Header from "./components/header/Header";
export default {
  components: {
    Header,
  },
  created() {
    this.$store.dispatch("churn/initialize");
  },
};
</script>
<style lang="scss">
// 2. Import default variables and available mixins.
@import "uikit/src/scss/variables-theme.scss";
@import "./style/variables-theme.scss";
@import "uikit/src/scss/mixins-theme.scss";

// 4. Import UIkit.
@import "uikit/src/scss/uikit-theme.scss";
</style>
